module.exports = __webpack_public_path__ + "static/media/7S.00b5eed0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/7S.svg
// module id = 76
// module chunks = 0